import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconRadiusBottomLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 8V5a.5.5 0 0 0-1 0v3a5.5 5.5 0 0 0 5.5 5.5h3a.5.5 0 0 0 0-1h-3A4.5 4.5 0 0 1 3 8m9.5 2.613a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m0-3a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-4.25-5.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m2.25.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-5.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.25 2.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomLeft16);
